import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import type { ICellRendererParams } from 'ag-grid-community'
import { Popover } from 'antd'
import moment from 'moment'
import React from 'react'

export function ScheduleRenderer({ data, value }: ICellRendererParams<Gravitate.SupplyOutage>) {
  const [showPopover, setShowPopover] = React.useState(false)
  const isRecurring = data.schedule_local.schedule_type === 'recurring'

  function handleShowPopover() {
    setShowPopover(true)
  }
  function handleHidePopover() {
    setShowPopover(false)
  }

  return (
    <div
      style={{
        cursor: isRecurring ? 'pointer' : 'default',
      }}
      onMouseOver={handleShowPopover}
      onFocus={handleShowPopover}
      onMouseOut={handleHidePopover}
      onBlur={handleHidePopover}
    >
      <Popover
        visible={showPopover && isRecurring}
        content={<PopoverContent data={data} />}
        overlayStyle={styles.popover}
      >
        <Texto weight={isRecurring && 'bold'}>{value}</Texto>
      </Popover>
    </div>
  )
}

function PopoverContent({ data }: { data: Gravitate.SupplyOutage }) {
  return (
    <div>
      {data.schedule_local.schedule_type === 'recurring' &&
        data.schedule_local.days.map((day) => {
          return (
            <Horizontal key={`${data.id}-${day.day_of_week}`}>
              <Texto style={styles.text}>{day.day_of_week}</Texto>
              <Texto>
                {moment(day.start_time, 'HH:mm').format('hh:mm A')} - {moment(day.end_time, 'HH:mm').format('hh:mm A')}
              </Texto>
            </Horizontal>
          )
        })}
    </div>
  )
}

const styles = {
  popover: {
    width: '250px',
  },
  text: {
    display: 'flex',
    flex: 1,
  },
}
